<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>

        <mat-list>
            <mat-list-item *ngFor="let document of data.documents; let i = index;">
                <div class="tw-w-64" matTooltip="{{document.name}}">{{ document.name | truncate:30 }}</div>
                <div class="tw-w-32">
                  <mat-select
                    [placeholder]="getCategory(document)"
                    (selectionChange)="updateDocument(i, $event.value )"
                  >
                    <mat-option [value]="null">
                      Choose Type
                    </mat-option>
                    <mat-option *ngFor="let category of data.categories; let i = index;" [value]="category.id">
                      {{ category.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <mat-divider></mat-divider>
            </mat-list-item>
        </mat-list>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="cancel-upload" (click)="cancel()">Cancel</button>
  <button mat-raised-button
          [color]="'primary'"
          [disabled]="disableSaveButton"
          (click)="save()">
    <span class="save-label">{{ saveButton }}</span>
  </button>
</mat-dialog-actions>

